var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { HeaderService, Site, SLD } from '@patsnap-utils/biz';
import { handleLogout } from '@patsnap-utils/passport';
import { getHelpCenterItems } from '@/infrastructure/utils/help-center';
import { inject, injectable } from '@/inversify.config';
import _ from 'lodash';
import { createLoginHref } from '@cores/startup/token-base';
import { HEADER_TYPE_CONFIG_MAP } from './constants';
import { E_HEADER_TYPE } from './enums';
import psHttp from '@patsnap/common-ps-http';
import { ACCOUNT_SERVICE_URI } from '@cores/constants/envConfig';
import { FeatureConfig } from '../feature-config/types/feature-config.interface';
import { I18nService } from '@/services/i18n-service';
let HeaderServiceManager = class HeaderServiceManager {
    constructor(i18n, featureConfig) {
        this.i18n = i18n;
        this.featureConfig = featureConfig;
        this.init();
    }
    getHeaderServiceInstance() {
        return this.headerService;
    }
    init() {
        this.headerService = new HeaderService();
        this.headerService.logoHref = new Site({ sld: SLD.HOME }).href;
        /* 注册登出回调函数 */
        this.headerService.userCenterService.logoutHandler = async function logout(done, logoutHref) {
            handleLogout().then((data) => {
                const href = _.get(data, 'data.redirect_url', logoutHref);
                window.location.href = href;
            });
        };
        /* 拦截登录 */
        // @ts-ignore
        this.headerService.userCenterService.beforeLogin = () => {
            window.location.href = createLoginHref(true, {
                errorCode: 39999,
                t: Math.floor(Date.now() / (5 * 60 * 1000)) * (5 * 60 * 1000),
            });
        };
    }
    syncHeaderAccountInfo() {
        return this.headerService.sync({
            http: psHttp,
            uri: ACCOUNT_SERVICE_URI,
        }).then(() => {
            const _info_ = this.headerService.account._info;
            return this.getAccountInfo(_info_);
        }).catch((e) => {
            // sync failed, 保持骨架
            this.headerService.syncing = true;
            throw e;
        });
    }
    setLocale() {
        const { locales } = this.headerService;
        this.headerService.locales = locales.map(({ active, ...rest }) => {
            return {
                ...rest,
                active: rest.key === this.i18n.locale,
            };
        });
    }
    getHelpCenter() {
        const i18n = this.i18n;
        const helpCenter = {
            icon: 'HelpCenter',
            trigger: 'hover',
            hasGuider: true,
            menu: getHelpCenterItems({
                $t(...rest) {
                    // @ts-ignore
                    return i18n.t(...rest);
                },
            }, this.featureConfig.region),
        };
        return helpCenter;
    }
    resetHeaderData(type) {
        const headerConfig = _.cloneDeep(HEADER_TYPE_CONFIG_MAP[type]);
        let title = headerConfig.title;
        let logoVisible = headerConfig.logoVisible;
        if (type === E_HEADER_TYPE.MAIN_VIEW) {
            title = this.i18n.t('groupMenu.workspace.title');
            logoVisible = !this.headerService.whiteLabel;
        }
        this.headerService.mountElement = '#workspace_header_wrapper';
        const helpCenter = this.getHelpCenter();
        this.headerService.title = title;
        this.headerService.logoVisible = logoVisible;
        this.headerService.customLogoVisible = headerConfig.customLogoVisible;
        this.headerService.visibleProducts = headerConfig.visibleProducts;
        this.headerService.helpCenterGuiderVisible = headerConfig.helpCenterGuiderVisible;
        this.initHelpGuider(type);
        this.headerService.left = headerConfig.left;
        this.headerService.right = headerConfig.right;
        if (type !== E_HEADER_TYPE.FREE_DETAIL_VIEW) {
            this.headerService.right.push(helpCenter);
        }
        return this.headerService;
    }
    getAccountInfo(accountInfo) {
        return {
            ...accountInfo,
            whiteLabel: this.headerService.whiteLabel,
            isHighLevelWhiteLabel: this.headerService.isHighLevelWhiteLabel,
        };
    }
    initHelpGuider(type) {
        const region = this.featureConfig.region;
        this.headerService.helpCenterGuiderVisible = true;
        let subModule = '';
        if (type === E_HEADER_TYPE.DETAIL_VIEW) {
            subModule = 'detail';
        }
        this.headerService.helpCenterGuiderConfig = {
            module: 'workspace',
            serviceArea: region.toLowerCase(),
            ...{
                subModule,
            },
        };
    }
    switchHelpCenter(subModule) {
        const region = this.featureConfig.region;
        this.headerService.helpCenterGuiderVisible = true;
        this.headerService.helpCenterGuiderConfig = {
            module: 'workspace',
            serviceArea: region.toLowerCase(),
            ...{
                subModule,
            },
        };
    }
};
HeaderServiceManager = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __param(1, inject(FeatureConfig)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof FeatureConfig !== "undefined" && FeatureConfig) === "function" ? _b : Object])
], HeaderServiceManager);
export { HeaderServiceManager };
